import { render, staticRenderFns } from "./BibView.vue?vue&type=template&id=4046df50&scoped=true&"
import script from "./BibView.vue?vue&type=script&lang=js&"
export * from "./BibView.vue?vue&type=script&lang=js&"
import style0 from "./BibView.vue?vue&type=style&index=0&id=4046df50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4046df50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
